/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react/index.js'
import Context from '@s-ui/react-context'
import SelectRange from '@adv-mt/mt-form-select-range'

const FormElectricBatteryCapacity = ({label, name, onChange, options, overlayContentRef, type, value, wrapper}) => {
  const {i18n} = useContext(Context)

  const optionsMapping = useMemo(
    () =>
      options.map(option => ({
        id: option,
        label: `${option} ${i18n.t('COMMON.UNIT_KWH').toLowerCase()}`
      })),
    [options]
  )

  return (
    <SelectRange
      description={htmlStringToReactElement(
        i18n.t('FILTERS.ELECTRIC_BATTERY_CAPACITY.DESCRIPTION', {brkLine: `<br/>`})
      )}
      fieldName={name}
      formatterLabel={({value}) => `${value} ${i18n.t('COMMON.UNIT_KWH').toLowerCase()}`}
      label={i18n.t(label)}
      onChange={onChange}
      options={{
        from: {name: 'from', options: optionsMapping},
        to: {name: 'to', options: optionsMapping}
      }}
      overlayContentRef={overlayContentRef}
      type={type}
      value={value}
      wrapper={wrapper}
    />
  )
}

FormElectricBatteryCapacity.displayName = 'FormElectricBatteryCapacity'
FormElectricBatteryCapacity.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.object,
  wrapper: PropTypes.string
}

export default FormElectricBatteryCapacity
